import { Injectable, NgZone } from '@angular/core';
import { ConfirmationDialogService } from '../../utilities/services/confirmation-dialog-service';

@Injectable({
  providedIn: 'root',
})
export class SessionTimeoutService {
  private timeoutId: any;

  private readonly IDLE_TIME = 5 * 60 * 1000; 

  constructor(
    private readonly dialogservice: ConfirmationDialogService,
    private readonly zone: NgZone
  ) {}

  startWatching(): void {
    this.resetTimer();

    [
      'mousemove',
      'mousedown',
      'keypress',
      'scroll',
      'touchstart',
      'click',
    ].forEach((event) => {
      window.addEventListener(event, () => this.resetTimer());
    });
  }

  private resetTimer(): void {
    clearTimeout(this.timeoutId);

    this.zone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => {
        this.zone.run(() => {
          this.showSessionTimeout();
        });
      }, this.IDLE_TIME);
    });
  }

  private reloadApplication(): void {
    window.location.reload();
  }
  
  private showSessionTimeout(): void {
    this.dialogservice
      .open({
        title: 'Session Timeout',
        message1:
          'Your session is inactive. Please acknowledge to refresh.',
        message2: '',
        yesText: 'OK',
        noText: '',
      })
      .subscribe(() => {
        this.reloadApplication();
      });
  }
}
